// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d35137d4","186":"f0b9857e","272":"1e0800f0","372":"f55244c3","630":"57d84334","841":"799d26cc","851":"95766d81","856":"fe44a51d","858":"7e964384"}[chunkId] + ".chunk.js";
};